'use client';
import Page from '@/pages/Wallet';
export default Page;